import { render, staticRenderFns } from "./campaign-copy-dialog.vue?vue&type=template&id=2102c9a3&scoped=true"
import script from "./campaign-copy-dialog.vue?vue&type=script&lang=js"
export * from "./campaign-copy-dialog.vue?vue&type=script&lang=js"
import style0 from "./campaign-copy-dialog.vue?vue&type=style&index=0&id=2102c9a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2102c9a3",
  null
  
)

export default component.exports